import { Textarea as CXTextArea } from '@sanlamcx/react-ui-next-textarea';

export const Textarea = CXTextArea;
